module.exports = __webpack_public_path__ + "img/forecast-img1.1a293b20.jpg";